import { AccountTransactionsResponse } from "../api";

export const getRelativeTransactionValue = (
  transaction: AccountTransactionsResponse["transactions"][number] & { date: Date; account: string },
) => {
  if (transaction.creditDebitIndicator === "DBIT") return transaction.amount.value * -1;
  return transaction.amount.value;
};
